import React from "react";
import { motion } from "framer-motion";

const fadeUp = {
  initial: { y: 30 },
  whileInView: { y: 0 },
  viewport: { once: true },
};

const DocentesSection = ({ docentes = [] }) => {
  if (!docentes.length) return null;

  return (
    <section id="docentes" className="py-10">
      <div className="max-w-6xl mx-auto px-4 md:px-0">
        <motion.div {...fadeUp} className="text-center mb-10">
          <h2 className="font-bold text-2xl">Nuestros docentes</h2>
        </motion.div>

        {/* 
          En móviles: Flexbox con overflow-x-auto, scroll snap y ancho fijo por card (w-[80vw] o w-[280px]).
          En md+: Se restaura la cuadrícula original (grid-cols-2 / xl:grid-cols-4).
        */}
        <div className="flex overflow-x-auto snap-x snap-mandatory gap-6 pb-6 scrollbar-none md:grid md:gap-8 md:grid-cols-2 xl:grid-cols-4 md:overflow-visible md:pb-0">
          {docentes.map((profe, index) => (
            <motion.div
              key={profe.id || index}
              {...fadeUp}
              transition={{
                duration: 0.5,
                delay: index * 0.1,
              }}
              whileHover={{ y: -10 }}
              className="flex-shrink-0 w-[80vw] max-w-[300px] snap-center overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm transition-all hover:shadow-2xl md:w-auto"
            >
              {profe.foto && (
                <div className="overflow-hidden h-[200px] w-full">
                  <img
                    src={profe.foto}
                    alt={profe.nombre}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
              )}

              <div className="p-6">
                <h3 className="text-base font-bold p-0">{profe.nombre}</h3>

                {profe.contenido && (
                  <div
                    className="link-with-arrow-1 [&_p]:text-sm mt-2"
                    dangerouslySetInnerHTML={{
                      __html: profe.contenido,
                    }}
                  />
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DocentesSection;